import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  FacebookContentImageRenderParams,
  FacebookContentImagesListParams,
  listFacebookContentImages,
  renderFacebookContentImage,
} from '~/services/PublicOfferFeedService';

export const facebookContentImagesQueryKeys = {
  all: ['facebookContentImages'] as const,
  lists: () => [...facebookContentImagesQueryKeys.all, 'list'] as const,
  list: (params?: FacebookContentImagesListParams) => [...facebookContentImagesQueryKeys.lists(), params] as const,
};

export function useGetFacebookContentImages(params?: FacebookContentImagesListParams) {
  return useQuery({
    queryKey: facebookContentImagesQueryKeys.list(params),
    queryFn: async () => {
      return await listFacebookContentImages(params);
    },
  });
}

export function useRenderFacebookContentImage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: FacebookContentImageRenderParams) => {
      return await renderFacebookContentImage(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facebookContentImagesQueryKeys.all });
    },
  });
}
